module.exports = __webpack_public_path__ + "Roboto-Thin.94998475f6aea65f5584.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/roboto/Roboto-Thin.ttf
// module id = 310
// module chunks = 2